
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sale/elitevillas/phuket",
      function () {
        return require("private-next-pages/sale/elitevillas/phuket.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sale/elitevillas/phuket"])
      });
    }
  